import { render, staticRenderFns } from "./ButtonRemoveFile.vue?vue&type=template&id=92e08730&scoped=true&"
import script from "./ButtonRemoveFile.vue?vue&type=script&lang=js&"
export * from "./ButtonRemoveFile.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRemoveFile.vue?vue&type=style&index=0&id=92e08730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e08730",
  null
  
)

export default component.exports